import moment from 'moment-timezone'

import { dayIdFromUnknownDate } from 'services/time_format'

const hasBookingKitDateField = (value) => (
  value != null
  && typeof value === 'object'
  && value.date != null
  && typeof value.date !== 'function'
)

/**
 * Canonical shape for `calendarList.calendar.day`: `{ id: 'YYYY-MM-DD', date }`.
 * booking-kit passes `{ id, date }`; mobile week strip may pass a raw Moment/Luxon/ISO.
 */
export const normalizeSelectedCalendarDay = (dayToSelect) => {
  if (dayToSelect == null) return null

  if (typeof dayToSelect === 'number') return null

  if (moment.isMoment(dayToSelect)) {
    if (!dayToSelect.isValid()) return null
    return { id: dayToSelect.format('YYYY-MM-DD'), date: dayToSelect }
  }

  if (hasBookingKitDateField(dayToSelect)) {
    const id = dayToSelect.id ?? dayIdFromUnknownDate(dayToSelect.date)
    if (!id) return null
    return id === dayToSelect.id ? dayToSelect : { ...dayToSelect, id }
  }

  const id = dayIdFromUnknownDate(dayToSelect)
  if (!id) return null

  return { id, date: dayToSelect }
}
